<template>
  <div
    class="home-root"
    style="
      background-color: #000;
      background-image: url(&quot;https://storage.googleapis.com/spacetech2/mdl/bg.png&quot;);
      min-height: 100vh;
      background-size: cover;
      padding-bottom: 15rem;
      background-attachment: fixed;
      overflow-y: scroll;
    "
  >
    <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
    <!-- <div class="col-12 d-flex my-0">
      <img
        class="mx-auto"
        src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
        alt=""
        style="width: 120px; height: 120px; margin-top: -22px"
      />
    </div> -->

    <Sticky>
      <div>
        <!-- <NavBar /> -->
        <div
          class="col-lg-12 col-12 mx-auto pt-2 px-2 d-flex main-image-wrapper"
        >
          <b-carousel
            id="carousel-1"
            :interval="3000"
            controls
            fade
            style="width: 100%"
          >
          <b-carousel-slide
              img-src="assets/Viber-Notice.jpg"
            ></b-carousel-slide>
            <!-- <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/mdl/0-02-06-49712d0b5263b434ae1db307796949aa249ce4b2d21dae2297ce42e120585c64_1c6dc24050a470.jpg"
            ></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/africanbuffalo/banners/MOL2.avif?ignoreCache=1"
            ></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/mdl/0-02-06-a11001fac15723f1826e20f0c9032a42a4cfe1f2c3eb4ff5f9efda9caecc0921_1c6dc2405f5af0.jpg"
            ></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/mdl/0-02-06-a1d8c20ef73bbf4ab49c9f5b81a22c337c8b01084e0dbb93c92fe488e8d9e4ac_1c6dc240508aff.jpg"
            ></b-carousel-slide> -->
          </b-carousel>
        </div>

        <div
          class="d-flex px-0 px-3 mx-auto my-2"
          style="
            width: 97%;
            z-index: 10;
            padding-top: 2px;
            padding-bottom: 2px;
            background: #1c2035 !important;
            border-radius: 15px;
            border: 1px solid #293057;
            box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
          "
        >
          <i
            class="fas fa-volume-up my-auto text-white pr-3"
            style="font-size: 14px; font-weight: 600"
          ></i>
          <NoticeBar
            class="mx-0 px-0 mx-auto notice-bar col-11"
            scrollable
            speed="40"
            :text="websiteInfo.noticeText"
            v-if="!threedData.embedded_link && !threedData.isLive"
          />
          <!-- websiteInfo[0]?.noticeText  -->
        </div>

        <!-- <div class="my-3 text-center py-2" style="background: #F4DC83; font-weight: 900; color: black;">
          TOP GAMES
        </div> -->
      </div>
    </Sticky>

    <div class="game-nav-scroll">
      <div class="game-nav-track">
        <div class="game-nav-track-inner" ref="gameNavTrack">
          <div
            v-for="item in gameNavItems"
            :key="item.key"
            class="game-nav-chip"
            :class="{ active: isGameNavActive(item) }"
            @click="changeSideNav(item.key)"
          >
            <img
              :src="item.icon"
              :alt="item.key"
              class="game-nav-chip__icon"
            />
            <span class="game-nav-chip__label">{{ $t(item.labelKey) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="cards-container-mobile">
      <div
        class="container-fluid justify-content-end px-0 d-flex pt-0"
        style="position: relative"
      >
        <div class="index_rightbar home-games-panel col-12 pl-2 pr-2">
          <div
            class="tab-content game px-2"
            style="min-height: 50vh; border-radius: 20px; height: auto; padding-bottom: 8rem;"
          >
              <div
                :class="sideNav === 'skm' ? 'active' : ''"
                v-if="sideNav === 'skm'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchShanKoMeeData(0)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchShanKoMeeData(1)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchShanKoMeeData(2)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchShanKoMeeData(3)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchShanKoMeeData(4)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchShanKoMeeData(5)"
                />
              </div>

              <div
                :class="sideNav === 'bgy' ? 'active' : ''"
                v-if="sideNav === 'bgy'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchBugyee(0)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchBugyee(1)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchBugyee(2)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchBugyee(3)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchBugyee(4)"
                />
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto"
                  @click="fetchBugyee(5)"
                />
              </div>

            <div
              v-if="sideNav === 'hot'"
              class="mx-1 mt-0 hot-games-panel active"
            >
              <div class="hot-games-intro">
                <i class="fas fa-fire hot-games-intro__icon"></i>
                <span class="hot-games-intro__title">{{ $t('home.hot') }}</span>
              </div>

              <p
                v-if="!hotGamesLoaded"
                class="hot-games__status"
              >
                {{
                  $store.state.language === 'en'
                    ? 'Loading hot games…'
                    : 'နာမည်ကြီးဂိမ်းများ ဖတ်နေပါသည်…'
                }}
              </p>

              <section
                v-for="section in hotGameSections"
                :key="section.key"
                class="hot-section"
              >
                <div class="hot-section__header">
                  <i :class="['fas', section.icon, 'hot-section__header-icon']"></i>
                  <h4 class="hot-section__title">{{ $t(section.titleKey) }}</h4>
                </div>

                <div
                  v-if="hotGames[section.key] && hotGames[section.key].length"
                  class="hot-section__grid"
                >
                  <div
                    v-for="game in hotGames[section.key]"
                    :key="game.id"
                    class="hot-game-card"
                  >
                    <div
                      class="hot-game-card__inner"
                      @click="handleHotGameClick(game)"
                    >
                      <!-- <img
                        class="hot-game-card__badge"
                        src="/assets/cards/icons/hot.png"
                        alt="Hot"
                      > -->
                      <img
                        class="hot-game-card__cover"
                        :src="imageLinkGenerate(game.gameID, game.provider)"
                        :alt="game.name || game.gameName || ''"
                        loading="lazy"
                        @error="onHotGameImageError"
                      >
                      <p class="hot-game-card__name">{{ game.name || game.gameName }}</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div
              v-if="activeCardSection"
              :key="activeCardSection.key"
              class="game-card-grid pb-2 mx-0 px-0 d-flex justify-content-between flex-wrap active"
            >
              <div
                v-for="card in activeCardSection.cards"
                :key="card.file || card.src"
                class="game-provider-card my-2 px-0 mx-0"
                :style="{ width: card.wide ? '100%' : '48%' }"
                @click="openGameCard(card)"
              >
                <img :src="cardImage(card)" :alt="card.alt" />
                <span v-if="card.label" class="game-provider-card__label">{{ card.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#ffffff" class="mx-auto" />
      </div>
    </van-overlay>

    <!-- <LiveChatWidget license="18638211" v-if="testing"/> -->

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div class="modal-dialog modal- modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br /><br />
              </span>
              <span>{{ limitText }}</span>
              <br /><br />
              <span class="text-dark text-sm">
                <button class="btn btn-danger" @click="gameInit(desiredGame)">
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import NavBar from '@/layouts/NavBar.vue';
import { NoticeBar, Dialog, Toast, Sticky } from "vant";
import { mapActions } from "vuex";
// import { LiveChatWidget } from '@livechat/widget-vue';
import * as spine from "@esotericsoftware/spine-player";
import "@esotericsoftware/spine-player/dist/spine-player.css";

export default {
  components: { NoticeBar, Sticky },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {},
        noticeText: "This is a notice",
      },
      isLogged: false,
      hotGames: {
        slotGames: [],
        fishingGames: [],
        arcadeGames: [],
      },
      hotGamesLoaded: false,
      limitText: "",
      desiredGame: null,
      sideNav: this.$store.state.sideNav,
      gameNavItems: [
        {
          key: 'hot',
          labelKey: 'home.hot',
          icon: '/assets/cards/icons/hot.png',
        },
        {
          key: 'lottery',
          labelKey: 'home.lottery',
          icon: '/assets/cards/icons/lottery.png',
        },
        {
          key: 'buffalo',
          labelKey: 'home.buffalo',
          icon: '/assets/cards/icons/buffalo.png',
        },
        {
          key: 'slot',
          labelKey: 'home.slot',
          icon: '/assets/cards/icons/slot.png',
        },
        {
          key: 'card',
          labelKey: 'home.card',
          icon: '/assets/cards/icons/card.png',
          activeKeys: ['card', 'bgy', 'skm'],
        },
        {
          key: 'fishing',
          labelKey: 'home.fishing',
          icon: '/assets/cards/icons/fishing.png',
        },
        {
          key: 'football',
          labelKey: 'home.football',
          icon: '/assets/cards/icons/football.png',
        },
        // {
        //   key: 'arcade',
        //   labelKey: 'home.arcade',
        //   icon: 'https://storage.googleapis.com/spacetech2/za9003d/icons/arcade.webp',
        // },
        // {
        //   key: 'casino',
        //   labelKey: 'home.casino',
        //   icon: 'https://storage.googleapis.com/spacetech2/za9003d/icons/Livecasino.webp',
        // },
      ],
      cardSections: [
        {
          key: 'lottery',
          cards: [
            { file: '2D.png', alt: '2D', to: '/user/2d/home' },
            { file: '3D.png', alt: '3D', to: '/user/3d/home' },
          ],
        },
        {
          key: 'buffalo',
          cards: [
            {
              file: 'AFrican Buffalo.png',
              alt: 'buffalo',
              wide: true,
              to: { path: '/user/slots', query: { provider: 'Buffalo' } },
            },
          ],
        },
        {
          key: 'slot',
          cards: [
            { file: 'slot/PP slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'Pragmatic' } } },
            { file: 'slot/JILI slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'Jili' } } },
            { file: 'slot/2J Slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: '2J' } } },
            { file: 'slot/Live22 slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'Live22' } } },
            { file: 'slot/FC slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'FaChai' } } },
            { file: 'slot/JDB slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'JDB' } } },
            { file: 'slot/ACEWIN slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'AceWin' } } },
            { file: 'slot/BNG slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'BNG' } } },
            { file: 'slot/R88 slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'Rich88' } } },
            { file: 'slot/Hotdog Slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'HotDog' } } },
            // { file: 'slot/PG slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'PGSoft' } } },
            { file: 'slot/Rich Gaming.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'Rich' } } },
            { file: 'slot/Ps Slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'Playstar' } } },
            { file: 'slot/KA slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'KA' } } },
            { file: 'slot/5G slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: '5G' } } },
            { file: 'slot/VA slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'VA' } } },
            { file: 'slot/BT Gaming Slot.png', alt: 'slot', to: { path: '/user/slots', query: { provider: 'BTG' } } },
          ],
        },
        {
          key: 'card',
          cards: [
            { file: 'Shankomee.png', alt: 'card', nav: 'skm' },
            { file: 'BUGYI.png', alt: 'card', nav: 'bgy' },
            { file: 'Forest.png', alt: 'card', method: 'forest' },
            { file: 'Kalone.png', alt: 'card', method: 'galone' },
          ],
        },
        {
          key: 'fishing',
          cards: [
            { file: 'fishing/JILI Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'Jili' } } },
            { file: 'fishing/JDB Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'JDB' } } },
            { file: 'fishing/2J Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: '2J' } } },
            { file: 'fishing/ACEWIN Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'AceWin' } } },
            { file: 'fishing/FC Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'FaChai' } } },
            { file: 'fishing/BNG Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'BNG' } } },
            { file: 'fishing/BTG Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'BTG' } } },
            { file: 'fishing/PP Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'Pragmatic' } } },
            { file: 'fishing/R88 Fish.png', alt: 'fishing', to: { path: '/user/fishing', query: { provider: 'Rich88' } } },
          ],
        },
        {
          key: 'football',
          cards: [
            {
              file: 'Body.png',
              alt: 'football',
              wide: true,
              to: '/body-fb',
            },
            {
              file: 'Maung.png',
              alt: 'football',
              wide: true,
              to: '/maung-fb',
            },
          ],
        },
        {
          key: 'arcade',
          cards: [
            { file: 'arcade/BT Arcade.png', alt: 'arcade', to: { path: '/user/arcade', query: { provider: 'BTG' } } },
            { file: 'arcade/FC Arcade.png', alt: 'arcade', to: { path: '/user/arcade', query: { provider: 'FaChai' } } },
            { file: 'arcade/PP Arcade.png', alt: 'arcade', to: { path: '/user/arcade', query: { provider: 'Pragmatic' } } },
          ],
        },
        {
          key: 'casino',
          cards: [
            { file: 'PP Live.png', alt: 'casino', wide: true, method: 'casino', provider: 'PP Live' },
          ],
        },
      ],
    };
  },
  computed: {
    activeCardSection() {
      return this.cardSections.find((section) => section.key === this.sideNav) || null;
    },
    hotGameSections() {
      return [
        { key: 'slotGames', titleKey: 'home.popular_slot_games', icon: 'fa-dice-five' },
        { key: 'fishingGames', titleKey: 'home.popular_fishing_games', icon: 'fa-fish' },
        { key: 'arcadeGames', titleKey: 'home.popular_arcade_games', icon: 'fa-gamepad' },
      ];
    },
  },
  destroyed() {
    this.testing = false;
  },
  watch: {
    "$store.state.sideNav"(newValue, oldValue) {
      this.sideNav = null;
      this.sideNav = newValue;
      // if (newValue) {
      //   this.$nextTick(() => {
      //     if(newValue === 'lottery'){
      //       this.updateLotteryContainer()
      //     } else if(newValue === 'slot'){
      //       this.updateSlotContainer()
      //     } else if(newValue === 'card'){
      //       this.updateCardContainer()
      //     } else if(newValue === 'football'){
      //       this.updateFootballContainer()
      //     } else if(newValue === 'fishing'){
      //       this.updateFishingContainer()
      //     }
      //   });
      // }
    },
  },
  methods: {
    updateLotteryContainer() {
      new spine.SpinePlayer("mm2d-container", {
        jsonUrl: "mm2d/MM2D.json",
        atlasUrl: "mm2d/MM2D.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("mm3d-container", {
        jsonUrl: "mm3d/MM3D.json",
        atlasUrl: "mm3d/MM3D.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });
    },

    updateSlotContainer() {
      new spine.SpinePlayer("jdb-slot-container", {
        jsonUrl: "jdb_slot/slot_jdb.json",
        atlasUrl: "jdb_slot/slot_jdb.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("fachai-slot-container", {
        jsonUrl: "fachai_slot/slot_fachai.json",
        atlasUrl: "fachai_slot/slot_fachai.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("5g-slot-container", {
        jsonUrl: "5g_slot/slot_5G.json",
        atlasUrl: "5g_slot/slot_5G.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("acewin-slot-container", {
        jsonUrl: "acewin_slot/slot_acewin.json",
        atlasUrl: "acewin_slot/slot_acewin.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });
    },

    updateCardContainer() {
      new spine.SpinePlayer("bgy-container", {
        jsonUrl: "BGY/BuuGyi.json",
        atlasUrl: "BGY/BuuGyi.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("skm-container", {
        jsonUrl: "SKM/Shankoemee.json",
        atlasUrl: "SKM/Shankoemee.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("forest-container", {
        jsonUrl: "forest/Forest Party.json",
        atlasUrl: "forest/Forest Party.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });
    },

    updateFootballContainer() {
      new spine.SpinePlayer("1x2-container", {
        jsonUrl: "1x2/scooer_1x2.json",
        atlasUrl: "1x2/scooer_1x2.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("body-container", {
        jsonUrl: "body/scooer_body.json",
        atlasUrl: "body/scooer_body.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("maung-container", {
        jsonUrl: "maung/scooer_parlay.json",
        atlasUrl: "maung/scooer_parlay.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("correct-container", {
        jsonUrl: "correctScore/scooer_Correct Score.json",
        atlasUrl: "correctScore/scooer_Correct Score.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });
    },

    updateFishingContainer() {
      new spine.SpinePlayer("acewin-fishing-container", {
        jsonUrl: "acewin_fishing/flshing_ace win.json",
        atlasUrl: "acewin_fishing/flshing_ace win.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });

      new spine.SpinePlayer("spade-fishing-container", {
        jsonUrl: "spade_fishing/flshing_spadegaming.json",
        atlasUrl: "spade_fishing/flshing_spadegaming.atlas",
        showControls: false,
        backgroundColor: "#00000000",
        alpha: true,
        animation: "animation",
        loop: true,
      });
    },

    async gameInitCasino(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const res = await axios.get("/games/url", {
          params: {
            provider: game,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        this.openProviderGame(res);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        // this.$router.go();
      }
    },
    openProviderGame(res) {
      const data = res?.data?.data ?? res?.data ?? {};
      let gameUrl = data.gameUrl ?? data.game_url ?? data.url ?? "";
      gameUrl = String(gameUrl || "").trim();
      const rawHtml =
        (typeof data.html === "string" && data.html) ||
        (gameUrl.startsWith("<") ? gameUrl : "");
      if (rawHtml) {
        gameUrl = URL.createObjectURL(
          new Blob([rawHtml], { type: "text/html;charset=utf-8" }),
        );
      }
      if (!gameUrl) return;
      this.$store.commit("setIframeURL", gameUrl);
      this.$router.push("/iframeURL");
    },
    hideLimit() {
      $("#limit").modal("hide");
    },

    async gameInit(game) {
      try {
        this.$store.commit("setLoading", true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
          this.$store.commit("setLoading", false);
          return;
        }
        if (authUser && !authUser.is_verified) {
          this.$router.push("/auth/verify");
          this.$store.commit("setLoading", false);
          return;
        }

        const res = await axios.get("/games/url", {
          params: {
            gameID: game.gameID,
            provider: game.provider,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        this.openProviderGame(res);

        this.$store.commit("setLoading", false);
      } catch (error) {
        this.$store.commit("setLoading", false);
      }
    },

    imageLinkGenerate(gameId, type) {
      if (type === "Jili") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
      }
      if (type === "Rich88") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${gameId}.webp`;
      }
      if (type === "Live22") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
      }
      if (type === "Spade") {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (type === "Fastspin") {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (type === "Playstar") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
      }
      if (type === "FaChai") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
      }
      if (type === "PGSoft") {
        return `https://new-cdn.myanmarshankoeme.com/AG_HOT_PG/${gameId}.avif`;
      }
      if (type === "JOKER" || type === "Joker") {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      }
      if (type === "5G") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
      }
      if (type === "KA") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
      }
      if (type === "AceWin") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
      }
      if (type === "JDB") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
      }
      if (type === "Buffalo" || type === "AfricanBuffalo") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
      }
      if (type === "HotDog") {
        return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      }
      if (type === "Rich") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
      }
      if (type === "CQ9" || type === "cq9" || type === "SexySlot") {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      }
      if (type === "BTG") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
      }
      if (type === "2J") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
      }
      if (type === "VA") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
      }
      if (type === "BNG") {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
      }
      if (type === 'AFGame') {
          return `https://cdn.myanmarshankoeme.com/build/assets/img/AFG-Square/${gameId}.webp`;
        }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },
    scrollToElement() {
      const container = this.$el.querySelector(".index_rightbar");
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    scrollActiveGameNavIntoView(behavior = "smooth") {
      this.$nextTick(() => {
        const track = this.$refs.gameNavTrack;
        if (!track) return;

        const activeChip = track.querySelector(".game-nav-chip.active");
        if (!activeChip) return;

        const chipLeft = activeChip.offsetLeft;
        const chipWidth = activeChip.offsetWidth;
        const trackWidth = track.clientWidth;
        const maxScroll = track.scrollWidth - trackWidth;
        const scrollLeft = chipLeft - trackWidth / 2 + chipWidth / 2;

        track.scrollTo({
          left: Math.min(maxScroll, Math.max(0, scrollLeft)),
          behavior,
        });
      });
    },
    handleHotGameClick(game) {
      this.gameInit(game);
    },
    isGameNavActive(item) {
      const keys = item.activeKeys || [item.key];
      return keys.includes(this.$store.state.sideNav);
    },
    onHotGameImageError(event) {
      const img = event.target;
      if (img.dataset.fallbackApplied) return;
      img.dataset.fallbackApplied = "1";
      img.src = "https://storage.googleapis.com/spacetech2/mdl/logo.png";
    },
    cardImage(card) {
      if (card.src) return card.src;
      return `/assets/cards/${card.file
        .split("/")
        .map((part) => encodeURIComponent(part))
        .join("/")}`;
    },
    openGameCard(card) {
      if (card.nav) {
        this.changeSideNav(card.nav);
        return;
      }
      if (card.method === "forest") {
        this.fetchForestData();
        return;
      }
      if (card.method === "galone") {
        this.fetchGaloneData();
        return;
      }
      if (card.method === "casino") {
        this.gameInitCasino(card.provider);
        return;
      }
      if (card.to) {
        this.$router.push(card.to);
      }
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game;
          this.gameLink = link;
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
        });
        window.location.assign(
          `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`,
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    alertBoxForLimit() {
      $("#balanceLimit").modal("show");
    },
    async fetchBugyee(level = null) {
      if (this.$store.state.authUser.game_balance < 1000) {
        this.alertBoxForLimit();
        return false;
      }

      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.game_balance;
        if (level == 0 && amount < 1000) {
          this.limitText =
            "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText =
            "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText =
            "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText =
            "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText =
            "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText =
            "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        const res = await axios.get("/bugyee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.game_balance,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // console.log(res.data)
        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchShanKoMeeData(level = null) {
      if (this.$store.state.authUser.game_balance < 1000) {
        this.alertBoxForLimit();
        return false;
      }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const amount = authUser.game_balance;
        if (level == 0 && amount < 1000) {
          this.limitText =
            "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText =
            "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText =
            "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText =
            "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText =
            "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText =
            "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText =
            "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $("#limit").modal("show");
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/shankomee-data", {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.game_balance,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3,
            },
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchForestData() {
      if (this.$store.state.authUser.game_balance < 1000) {
        this.alertBoxForLimit();
        return false;
      }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/forest-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneData() {
      if (this.$store.state.authUser.game_balance < 1000) {
        this.alertBoxForLimit();
        return false;
      }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        const res = await axios.get("/galone-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (res.data.url) {
          window.location.assign(res.data.url);
        } else {
          Dialog.alert({
            message: res.data.description,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    // async gameInit(game) {
    //   try {
    //     this.isLoading = true;
    //     const authUser = await this.fetchUser();
    //     if (!authUser) {
    //       this.$router.push('/auth/login');
    //     }

    //     const res = await axios.get('/games/url', {
    //       params: {
    //         provider: game
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('token')}`,
    //       },
    //     });

    //     window.open(res.data.data.gameUrl, "_self");
    //     // this.$store.commit('setIframeURL', res.data.data.gameUrl);
    //     // this.$store.commit('setIsCardGame', false);
    //     // this.$router.push('/iframeURL');

    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     // this.$router.go();
    //   }
    // },
    changeSideNav(para) {
      this.$store.commit("updateSideNav", para);
      this.scrollToElement();
      this.scrollActiveGameNavIntoView();
    },
    ...mapActions(["logoutUser", "fetchUser"]),
    // async redirectRoute(path, query = null) {
    //   try {
    //     console.log('query', query)
    //     if(query) {
    //       this.$router.push({ path, query });
    //     } else {
    //       this.$router.push(path);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    // logout() {
    //   Dialog.confirm({
    //     title:
    //       this.$store.state.language === 'en'
    //         ? 'Are you sure to log out?'
    //         : 'ထွက်မှာ သေချာပါသလား?',
    //     cancelButtonText:
    //       this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
    //     confirmButtonText:
    //       this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
    //   })
    //     .then(async () => {
    //       await this.logoutUser();
    //       this.$router.push('/auth/login');
    //       Toast.success(
    //         this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
    //       );
    //     })
    //     .catch(() => {});
    // },
    // async redirectRoute(path, query = null) {
    //   try {
    //     if (path === 'tip') {
    //       const text = this.$store.state.language === 'en'
    //         ? 'This feature is not support yet.'
    //         : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
    //       Dialog.alert({
    //         message: text,
    //         confirmButtonText:
    //                 this.$store.state.language === 'en'
    //                   ? 'Okay'
    //                   : 'Okay',
    //       }).then(() => {
    //       // on close
    //       });
    //     } else if(query) {
    //       this.$router.push({ path, query });
    //     } else {
    //       this.$router.push(path);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // threedDrawDateFormat(date) {
    //   return moment(date).format('ll');
    // },
    // async fetchTwoDdata() {
    //   try {
    //     const res = await axios.get('/2d/data');
    //     this.isLive = res.data.data[0].isLive;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async fetchWebsiteData() {
      try {
        const res = await axios.get("/website-infos");
        this.websiteInfo = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    // async fetchThreedDdata() {
    //   try {
    //     const res = await axios.get('/3d/data');
    //     this.threedData = res.data.data[0];
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async fetchHotGames() {
      try {
        const client = axios.create({
          baseURL: axios.defaults.baseURL,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });
        if (client.defaults.headers.common) {
          delete client.defaults.headers.common.Authorization;
        }
        const res = await client.get("/hot-games");
        if (this._isDestroyed) return;
        const data = (res && res.data && res.data.data) || {};
        this.hotGames = {
          slotGames: Array.isArray(data.slotGames) ? data.slotGames : [],
          fishingGames: Array.isArray(data.fishingGames) ? data.fishingGames : [],
          arcadeGames: Array.isArray(data.arcadeGames) ? data.arcadeGames : [],
        };
      } catch (error) {
        console.log(error);
      } finally {
        if (!this._isDestroyed) this.hotGamesLoaded = true;
      }
    },
    // async fetchTwoThreeDHistories() {
    //   try {
    //     const twoDres = await axios.get('/twod_history');
    //     const threeDres = await axios.get('/threed_history');
    //     this.twoDHistories = twoDres.data.data;
    //     this.threeDHistories = threeDres.data.data;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    // applyCustomStyles() {
    //   var tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.style.bottom = '7rem'; // Adjust this as needed
    //     tawkIframe.style.left = '1rem';
    //     tawkIframe.style.right = '0rem';
    //   }
    // },
    // // Function to remove the Tawt.io script and widget
    // removeTawkChat() {
    //   const tawkScript = document.getElementById('tawk-io-chat');
    //   if (tawkScript) {
    //     tawkScript.remove(); // Remove the script tag
    //   }

    //   // Remove the Tawk.to iframe widget
    //   const tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.remove();
    //   }
    // }
  },
  async mounted() {
    this.fetchHotGames();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    // this.$store.commit('setLoading', true);
    await this.fetchWebsiteData();
    this.scrollActiveGameNavIntoView("auto");

    // this.$store.commit('setLoading', false);
    // this.updateSlotContainer();
  },
  // beforeDestroy() {
  //   this.removeTawkChat();
  // }
};
</script>
<style scoped>
.home-root {
  -webkit-overflow-scrolling: touch;
}

.game-nav-scroll {
  width: 100%;
  padding: 0.35rem 0.45rem 0.15rem;
}

.game-nav-track {
  width: 100%;
  border-radius: 8px;
  background: #1c2035;
  border: 1px solid #293057;
  padding: 0.2rem;
  box-sizing: border-box;
  overflow: hidden;
}

.game-nav-track-inner {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  align-items: center;
}

.game-nav-track-inner::-webkit-scrollbar {
  display: none;
}

.game-nav-chip {
  flex: 0 0 auto;
  min-width: 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.35rem 0.55rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  white-space: nowrap;
}

.game-nav-chip.active {
  padding: 0.45rem 0.75rem;
  background: linear-gradient(180deg, #242a4f, #2a399d);
  color: #fae63c;
}

.game-nav-chip__icon {
  width: 1.55rem;
  height: 1.55rem;
  object-fit: contain;
  flex-shrink: 0;
}

.game-nav-chip__label {
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1;
}

.game-provider-card {
  position: relative;
  cursor: pointer;
}

.game-provider-card img {
  width: 100%;
  height: auto;
  display: block;
}

.game-provider-card__label {
  position: absolute;
  left: 50%;
  bottom: 0.75rem;
  transform: translateX(-50%);
  color: #ffffff;
  font-weight: 500;
  white-space: nowrap;
}

.hot-games__status {
  color: #ffffff;
  text-align: center;
  margin: 1.5rem 0;
}

.hot-games-panel {
  padding: 0.15rem 0 0.5rem;
}

.hot-games-intro {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
  padding: 0.55rem 0.75rem;
  background: linear-gradient(180deg, #242a4f, #2a399d);
  border-radius: 10px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
}

.hot-games-intro__icon {
  color: #fae63c;
  font-size: 1.15rem;
}

.hot-games-intro__title {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.hot-section {
  margin-bottom: 0.85rem;
  background: #1c2035;
  border-radius: 12px;
  padding: 0.65rem 0.7rem 0.75rem;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
  border: 1px solid #293057;
}

.hot-section__header {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.65rem;
  padding-bottom: 0.45rem;
  border-bottom: 2px solid #293057;
}

.hot-section__header-icon {
  color: #fae63c;
  background: linear-gradient(180deg, #242a4f, #2a399d);
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  flex-shrink: 0;
}

.hot-section__title {
  color: #fae63c;
  font-size: 0.92rem;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  flex: 1;
}

.hot-section__grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.2rem;
}

.hot-game-card {
  width: 25%;
  padding: 0.25rem;
}

.hot-game-card__inner {
  position: relative;
  background: #212746;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #293057;
  cursor: pointer;
  transition: transform 0.15s ease;
}

.hot-game-card__inner:active {
  transform: scale(0.96);
}

.hot-game-card__badge {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  width: 22px;
  height: 22px;
  pointer-events: none;
}

.hot-game-card__cover {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.hot-game-card__name {
  font-size: 0.68rem;
  font-weight: 600;
  color: #ffffff;
  padding: 0.3rem 0.35rem 0.4rem;
  margin: 0;
  text-align: center;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.main-image-wrapper >>> #carousel-1 {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.4);
}

.spine-container {
  width: 50% !important;
  height: 20vh !important;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.side-nav-icon-text {
  /* color: #A80000; */
  font-size: 0.9rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: #fae63c !important;
  background: #212746;
  transition: background 0.2s ease;
}

.side-nav-icon.active {
  background: linear-gradient(180deg, #242a4f, #2a399d);
  color: #fae63c !important;
}
.side-nav-icon-text.active {
  color: #fae63c !important;
}

.sidebar {
  position: fixed;
  left: 0;
  height: 55vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-y: auto;
}

.index_rightbar {
  padding: 0px 10px;
  overflow-y: auto;
  height: 62vh;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.index_rightbar::-webkit-scrollbar {
  display: none;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid #714dc7;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #714dc7;
  cursor: pointer;
  display: inline-block;
  font-family:
    Roobert,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Helvetica,
    Arial,
    sans-serif,
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background-color: #714dc7;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
}

.nav-pills.game-nav {
  padding-right: 5px;
}
.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  /* padding: 10px; */
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
  /* background: linear-gradient(#aa9ace, #714DC7); */
}
.nav-pills:not(.nav-pills-circle) .nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 100px;
}

.nav-pills .nav-link img {
  width: 18px !important;
  /* margin-right: 10px; */
  padding-bottom: 4px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff !important;
  background: linear-gradient(#fff, #8a69d9);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}
.tab-content.game {
  padding-left: 3px;
}
.tab-content > .tab-pane {
  display: none;
  padding-right: 3px;
}
.tab-content > .active {
  display: block;
}

.css-38745a {
  margin: 0px;
  line-height: 1.5;
  font-size: 12px;
  font-family: NotoSansMyanmar;
  font-weight: 500;
}
.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}
.card {
  cursor: pointer;
  border-radius: 10px !important;
}
.main-image-wrapper img {
  width: 100%;
}
.video-container {
  height: 500px;
  width: 100%;
}
.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: white !important;
  background: transparent;
}
.twod-threed-cards {
  height: 200px;
}
.live-number {
  font-weight: bold;
  font-size: 25px;
}
.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.not-live-text {
  font-weight: bold;
  font-size: 24px;
}
.cards-container {
  display: flex;
  flex-wrap: wrap;
}
.card-body {
  padding: 0px !important;
}
.cards-container-mobile {
  display: none;
}
@keyframes live-number-animation {
  from {
    color: white;
  }
  to {
    color: red;
  }
}

/* @media (max-width: 768px) { */
/* .middle-container {
    padding-top: 0.1rem !important;
  } */
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}
.video-container {
  height: 300px;
  width: 100%;
}
.main-wrapper {
  padding: 7px !important;
}
.notice-bar {
  margin-top: 0px;
  height: 25px;
  z-index: 1;
  font-size: 1rem;
  color: white !important;
  background: transparent;
  border-radius: 7px;
}
.live-number {
  font-weight: bold;
  font-size: 20px;
}
.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}
.cards-container-mobile {
  padding: 0px !important;
  margin-top: 5px !important;
  display: flex;
  flex-wrap: wrap;
}
.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}
.card-body {
  padding: 0px !important;
}
.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: #000000;
  /* background: linear-gradient(#aa9ace, #714DC7); */
  box-shadow:
    0 4px 6px rgba(50, 50, 93, 0.11),
    0 1px 3px rgba(0, 0, 0, 0.08);
}
.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}
.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}
.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}
/* } */
</style>
